import type { CompleteUser } from '../types';

export function canManageAccountSettings(
  user: Pick<CompleteUser, 'accessLevel'> | null | undefined
): boolean {
  return user?.accessLevel === 'OWNER' || user?.accessLevel === 'ADMIN';
}

export function accountAllowsPrivateValidations(
  user: Pick<CompleteUser, 'company'> | null | undefined
): boolean {
  return user?.company?.allowsPrivacy === true;
}

export function canSetPersonalPrivateDefault(
  user: Pick<CompleteUser, 'company' | 'privacy_enabled'> | null | undefined
): boolean {
  return accountAllowsPrivateValidations(user) && user?.privacy_enabled === true;
}

export function canChoosePrivateSharing(
  user: Pick<CompleteUser, 'accessLevel' | 'company' | 'privacy_enabled'> | null | undefined
): boolean {
  return canManageAccountSettings(user) || canSetPersonalPrivateDefault(user);
}

export function defaultValidationPrivacy(
  user: Pick<CompleteUser, 'company' | 'privacy_enabled' | 'prefrences'> | null | undefined
): 'PRIVATE' | 'PUBLIC' {
  if (canSetPersonalPrivateDefault(user) && user?.prefrences?.privateValidations) {
    return 'PRIVATE';
  }
  return 'PUBLIC';
}

export function canAccessSecuritySettings(
  user: Pick<CompleteUser, 'accessLevel' | 'company'> | null | undefined
): boolean {
  return (
    canManageAccountSettings(user) ||
    user?.company?.authenticate_mode === 'Default'
  );
}
